/**
 * 极简OSS图片鉴权过滤器
 * 功能：接收原始URL → 用STS凭证签名 → 返回可访问的签名URL
 */
import OSS from 'ali-oss';
// import {
// 	getValidStsToken
// } from './sts.js';

const urlCache = new Map();
// 缓存过期时间（单位：毫秒），设置为略小于签名URL的有效期（例如23小时）
const CACHE_EXPIRE_MS = 60 * 1000;
// 固定配置（不用改）
const OSS_CONFIG = {
	bucket: 'marathon-bm-file',
	region: 'oss-cn-beijing',
	endpoint: 'https://oss-cn-beijing.aliyuncs.com',
	// endpoint: 'https://file.marathonbm.com',
	baseDomain: 'https://file.marathonbm.com',
	expires: 60, // 签名有效期24小时
};
// 中文路径编码（避免中文报错）
function encodeChinesePath(key) {
	return key.split('/').map(seg => /[\u4e00-\u9fa5]/.test(seg) ? encodeURIComponent(seg) : seg).join('/');
}
// 核心鉴权方法（直接返回签名URL）
export function ossPictures(originalUrl) {
	// 无效URL直接返回
	if (!originalUrl || typeof originalUrl !== 'string') {
		return originalUrl
	}
	originalUrl = originalUrl.split('?')[0]
	// ====================== 新增：检查缓存 ======================
	const cachedItem = urlCache.get(originalUrl);
	// if (cachedItem) {
	// 	const {
	// 		signedUrl,
	// 		timestamp
	// 	} = cachedItem;
	// 	// 如果缓存未过期，则直接返回缓存的URL
	// 	if (Date.now() - timestamp < CACHE_EXPIRE_MS) {
	// 		console.log(`使用缓存的签名URL for ${originalUrl}`);
	// 		return signedUrl;
	// 	} else {
	// 		// 缓存已过期，从缓存中移除
	// 		urlCache.delete(originalUrl);
	// 		console.log(`缓存的URL已过期，将重新签名 for ${originalUrl}`);
	// 	}
	// }

	//设置自定义bucket
	// getBucketByCoverImage(originalUrl)
	try {
		const {
			accessKeyId,
			accessKeySecret,
			securityToken
		} = JSON.parse(sessionStorage.getItem('sts_token_anonymous'))
		// console.log(accessKeyId)
		// 2. 初始化OSS客户端
		const client = new OSS({
			accessKeyId: accessKeyId,
			accessKeySecret: accessKeySecret,
			stsToken: securityToken,
			bucket: OSS_CONFIG.bucket,
			endpoint: OSS_CONFIG.endpoint,
			refreshSTSToken:'',
			refreshSTSTokenInterval: 70000000,
			cname: false, //临时关闭自定义域名（避免域名解析到杭州）
		});

		// 3. 截取并编码文件路径
		const [, objectKey] = originalUrl.split(OSS_CONFIG.baseDomain);
		// const encodedKey = encodeChinesePath(objectKey);	
		// 4. 生成签名URL（兼容所有ali-oss版本）
		const signedUrl = client.signatureUrl(objectKey, {
			expires: OSS_CONFIG.expires
		});
		//暂时拼接requestId
		let arr = ['982285707324166266', '982285927139250176', '982285927139250181', '982285927139250186',
			'982285927139250178'
		]
		let jiami = arr[Math.floor(Math.random() * arr.length)]
		 const finalUrl = `${signedUrl}&requestId=${jiami}`;
		// ====================== 新增：存入缓存 ======================
		urlCache.set(originalUrl, {
			signedUrl: finalUrl,
			timestamp: Date.now()
		});

		return finalUrl;
	} catch (error) {
		console.error('鉴权失败，返回原始URL：', error.message);
		return originalUrl; // 报错也返回原始URL，至少能试下能不能直接访问
	}
}
/**
 * 根据 coverImage 地址匹配对应的 bucket
 * @param {string} coverImage - 图片完整地址（如：https://file.marathonbm.com/2000/201/file/2025_06/11751016532143.png）
 * @returns {Object} { endpoint: 提取的域名, bucket: 匹配的bucket, error: 错误信息（无则为null） }
 */
function getBucketByCoverImage(coverImage) {
	// 定义 endpoint 和 bucket 的映射关系（按你的需求配置）
	const endpointBucketMap = [{
			endpoint: 'https://file.marathonbm.com',
			bucket: 'marathon-bm-file'
		},
		{
			endpoint: 'https://marathon-image.hpaopao.com',
			bucket: 'marathon-image'
		},
		{
			endpoint: 'https://static.hpaopao.com',
			bucket: 'marathon-webs'
		},
		{
			endpoint: 'https://marathon-web.hpaopao.com',
			bucket: 'marathon-webs'
		},
		{
			endpoint: 'https://paopao-image.hpaopao.com',
			bucket: 'paopao-image'
		},
		{
			endpoint: 'https://psq-img.hpaopao.com',
			bucket: 'psq-image'
		},
		{
			endpoint: 'https://files-test.marathonbm.com',
			bucket: 'yanxiaojing-test'
		}
	];

	try {
		// 1. 验证 coverImage 是否为有效URL
		const urlObj = new URL(coverImage);
		// 2. 提取完整 endpoint（协议 + 域名，如：https://file.marathonbm.com）
		const extractedEndpoint = `${urlObj.protocol}//${urlObj.host}`;

		// 3. 匹配对应的 bucket
		const matchItem = endpointBucketMap.find(item => item.endpoint === extractedEndpoint);

		if (matchItem) {
			OSS_CONFIG.endpoint = matchItem.endpoint
			OSS_CONFIG.bucket = matchItem.bucket
			// return {
			//   endpoint: matchItem.endpoint,
			//   bucket: matchItem.bucket,
			//   error: null
			// };
		} else {
			return {
				endpoint: extractedEndpoint,
				bucket: '',
				error: `未找到匹配的 bucket，当前 endpoint：${extractedEndpoint}`
			};
		}
	} catch (err) {
		return {
			endpoint: '',
			bucket: '',
			error: `图片地址无效：${err.message}`
		};
	}
}

// 注册全局过滤器（main.js调用）
export function registerOssFilter(Vue) {
	// 注意：异步方法不能直接当过滤器，用$nextTick处理
	Vue.filter('$ossPictures', function(originalUrl) {
		return ossPictures(originalUrl)
	});
	Vue.prototype.$ossPictures = function(data) {
		//   console.log(data)
		return ossPictures(data)
	}
	//修改html图片，edit是获取富文本后显示，del是提交的时候去除富文本鉴权后的多余参数
	Vue.prototype.$ossshowHtml = function(data,flag) {
		//   console.log(data)
		return showHtml(data,flag)
	}
}

// export const showHtml = (str) => {
// 	// console.log(str)
// 	var s = '';
// 	if (str.length === 0) {
// 		return '';
// 	}
// s = str.replace(/&amp;/g, '&');
// 	s = s.replace(/&lt;/g, '<');
// 	s = s.replace(/&gt;/g, '>');
// 	s = s.replace(/&nbsp;/g, ' ');
// 	s = s.replace(/&#39;/g, '\'');
// 	s = s.replace(/&quot;/g, '\"');
// 	s = s.replace(/&ldquo;/g, '“')
// 	s = s.replace(/&rdquo;/g, '”')
// 	s = s.replace(/style='[^']+'/gi, "") //小程序展示要自己统一的样式，替换了行内样式
// 	s = s.replace(/(<!--(.|[\r\n])*?-->)/gi, "") //替换了注释的内容这能替掉大部分
// 	s = s.replace(/<xml[^>]*>(.|\n)*<\/xml>/gi, "") //替换了xml标签<xml></xml>word粘贴带出一堆标签包含在xml里干掉它
// 	s = s.replace(/undefined/g, "") //里面莫名有个undefined 干掉


// // 正则表达式匹配所有的img标签
// 	let imgRegex = /<img[^>]*src="([^"]+)"[^>]*>/g;
// 	// let imageRegex = /<image[^>]*src="([^"]+)"[^>]*>/g;
  
// 	// 使用正则表达式找到所有的图片链接
// 	let match = [];
// let reg = new RegExp(imgRegex, "g");
// // console.log('富文本图片---》',match)
// 	while ((match = reg.exec(s))) {
// 		// 修改图片链接
// 		let newSrc =ossPictures(match[1]);
// 		s = s.replace(match[1], newSrc);
// 	}
// 	return s;
// }

// 富文本图片URL处理（精简版）
export const showHtml = (value, flag) => {
  if (!value) return value; // 空值直接返回

  // 步骤1：先还原转义字符（解决&amp;问题）
  let processedValue = value.replace(/&amp;/g, '&');

  // 合并img/image标签正则（保留g+i，仅用于抓取）
  const imgRegexList = [
    /<img[^>]+src="([^">]+)"/gi,
    /<image[^>]+src="([^">]+)"/gi
  ];

  // 步骤2：先全量抓取所有需要处理的oldSrc（基于原始字符串，不修改）
  const allOldSrcs = new Set(); // 用Set去重，避免重复处理
  imgRegexList.forEach(regex => {
    regex.lastIndex = 0; // 强制重置游标，从头开始
    let matchs;
    // 仅抓取，不修改字符串
    while ((matchs = regex.exec(processedValue)) !== null) {
      allOldSrcs.add(matchs[1]); // 存入Set，自动去重
    }
  });

  // 步骤3：统一处理图片链接的公共方法
  const handleImageSrc = (src) => {
    const handleFunc = flag === 'edit' ? ossPictures : handleDelContent;
    console.log('处理前：', src, '处理后：', handleFunc(src));
    return handleFunc(src);
  };

  // 步骤4：批量替换所有抓取到的oldSrc（全局替换，避免漏改）
  allOldSrcs.forEach(oldSrc => {
    const newSrc = handleImageSrc(oldSrc);
    // 转义特殊字符 + 全局替换（确保所有相同URL都被替换）
    const escapedOldSrc = oldSrc.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    processedValue = processedValue.replace(new RegExp(escapedOldSrc, 'g'), newSrc);
  });

  return processedValue;
};

// 移除URL中的requestId参数
function handleDelContent(url) {
  if (!url) return url;
// console.log('抓取了数据',url)
  // 统一转为数组处理，消除字符串/数组分支
  const urlArr = Array.isArray(url) ? url : url.split(',');
  // 匹配需要处理的域名
  const domainList = [
    'file.marathonbm.com',
    'marathon-image.hpaopao.com',
    'static.hpaopao.com',
    'marathon-web.hpaopao.com',
    'paopao-image.hpaopao.com',
    'psq-img.hpaopao.com'
  ];

  const urls = urlArr.map(item => {
    // 仅处理包含指定域名且有requestId的URL
    const hasTargetDomain = domainList.some(domain => item.includes(domain));
    if (hasTargetDomain && item.includes('OSSAccessKeyId=')) {
      return item.split('?')[0]
    }
    return item;
  });

  // 还原原数据类型（数组/字符串）
  return Array.isArray(url) ? urls : urls.join(',');
}

